import type { AppState } from '../rootReducer';

export const canAddNewPaymentMethod = (state: AppState) =>
  state.paymentMethods.canAddNewPaymentMethod;
